// project import
import dashboard from './dashboard';
import utilities from './utilities';
import pharma from './pharma';
import OrderMgmt from './ordermgmt';
import PharmaConfiguration from './pharmaconfiguration';
import RMMgmt from './rmmgmt';
import DesignMgmt from './designmgmt';
import QAMgmt from './qamgmt';
import VendorMgmt from './vendormgmt';
import Sales from './sales';
import Accounts from './accounts';
import StoreMgmt from './storemgmt';
import CollaborationMenu from './collaborationmenu';
import PharmaAdmin from './pharmaadmin';
import OrderStatus from './orderstatus';



// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [OrderMgmt,OrderStatus,PharmaConfiguration,CollaborationMenu,PharmaAdmin,dashboard, pharma, utilities]
};

export default menuItems;